var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',[(typeof _vm.imgSource !== 'undefined')?_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":_vm.imgSource}}):_c('v-skeleton-loader',{attrs:{"type":"image"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }